import { environment } from '../../environments/environment';

export const AppConfig = {
    outages: environment.baseUrl + 'outages/',
    createToken: environment.baseUrl + 'api-token-auth/',    
}